import { useQuery } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/api-key'
import { useQueryParams } from 'ssr/router'

import {
  GetMapByIdForPublicQuery,
  QueryGetMapByIdForPublicArgs
} from '~map-access/types/__generated/gql/graphql'

export const getMapByIdForPublicKey = (mapId: string) => [
  'getMapByIdForPublic',
  mapId
]

export const getMapByIdForPublicQuery = /* GraphQL */ `
  query GetMapByIdForPublic($id: ID!) {
    getMapByIdForPublic(id: $id) {
      id
      name
      workspace {
        id
        name
      }
      creator {
        id
        firstName
        lastName
        email
      }
    }
  }
`

export function useGetMapByIdForPublic() {
  const { mapId } = useQueryParams()

  return useQuery({
    queryKey: getMapByIdForPublicKey(mapId),
    queryFn: async () => {
      const data = await graphql<
        GetMapByIdForPublicQuery,
        QueryGetMapByIdForPublicArgs
      >({
        query: getMapByIdForPublicQuery,
        variables: {
          id: mapId
        }
      })

      return data?.getMapByIdForPublic
    }
  })
}
